export default "__VITE_ASSET__DccyxmHU__"